<template>
  <div class="login-form">
    <h2>Login</h2>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="username">Username</label>
        <input type="text" id="username" v-model="username" required />
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" id="password" v-model="password" required />
      </div>
      <button type="submit" class="btn btn-primary" :disabled="isLoading">
        {{ isLoading ? 'Loading...' : 'Login' }}
      </button>
    </form>
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: "LoginForm",
  props: {
    redirectHome: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      username: '',
      password: '',
      error: '',
      isLoading: false
    };
  },
  methods: {
    async login() {
      this.isLoading = true;
      this.error = '';
      
      try {
        const authStore = useAuthStore();
        await authStore.login(this.username, this.password);
        
        // Emit event to parent component if used inside a modal
        this.$emit("login-success");

        // Redirect to home page using Vue Router
        if (this.redirectHome) {
          this.$router.push('/');
        }
      } catch (err) {
        console.error("Login error:", err);
        this.error = 'Login gagal. Periksa username dan password Anda.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-form {
  text-align: center;
}

.form-group {
  text-align: left;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.btn-primary {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  background-color: #488e71;
  color: white;
}

.btn-primary:hover {
  background-color: #3a7259;
}

.btn-primary:disabled {
  background-color: #93c3b1;
  cursor: not-allowed;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>